import { render, staticRenderFns } from "./TSZ_Listados.vue?vue&type=template&id=63186407&"
import script from "./TSZ_Listados.vue?vue&type=script&lang=js&"
export * from "./TSZ_Listados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports